import React from 'react';
import Navbar from './components/NavBar';
import BackButton from './components/BackButton';
import './Layout.css'; // We'll create this CSS file for layout styling

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div>
      <Navbar />
      <BackButton />
      <div className="content">{children}</div>
    </div>
  );
};

export default Layout;